<template>
	<div>
		<BCard>
			<template v-if="user.stripe_card_id">
				<BRow>
					<BCol lg="6">
						<BCard bg-variant="light">
							<div
								class="d-flex justify-content-between align-items-center mb-3 border-bottom border-light">
								<h3 class="mb-0">
									Your Current Card
								</h3>
								<div class="d-flex gap-sm">
									<BButton
										variant="white"
										class="d-inline-flex align-items-center"
										@click="$bvModal.show('credit-card-modal')">
										<BIcon icon="pencil-square" class="mr-2"></BIcon>
										Update
									</BButton>
									<template v-if="isCleaner">
										<BButton
											variant="outline-danger"
											class="d-inline-flex align-items-center"
											@click="$bvModal.show('remove-credit-card-modal')">
											<BIcon icon="trash" class="mr-2"></BIcon>
											Remove
										</BButton>
									</template>
								</div>
							</div>
							<hr />
							<credit-card :brand="user.stripe_card_brand" :last-four="user.stripe_card_last_four" />
						</BCard>
					</BCol>
				</BRow>
			</template>
			<template v-else>
				<h3>Add Your Credit Card</h3>
				<p>
					You currently have no credit card on file. Please enter your credit card details below. We will use
					this card to charge you for your bookings.
				</p>
				<credit-card-form ref="creditCardForm" :country="user.country" />
				<hr class="border-light" />
				<div class="d-flex justify-content-between mt-2">
					<div>
						<img src="/assets/img/powered-by-stripe.svg" style="height: 24px" />
					</div>
					<div>
						<BButton variant="primary" :disabled="submitting"
							@click="submit">
							<BSpinner v-if="submitting" small
								class="mr-2"></BSpinner>
							Save Card
						</BButton>
					</div>
				</div>
			</template>
		</BCard>
		<credit-card-modal id="credit-card-modal" @card-updated="cardUpdated" />
		<BModal id="remove-credit-card-modal" title="Remove Credit Card"
			centered>
			<div>Are you sure you want to remove your credit card?</div>
			<template #footer>
				<div class="d-flex justify-content-end gap-sm">
					<BButton variant="outline-secondary" @click="$bvModal.hide('remove-credit-card-modal')">
						No, Keep my Card
					</BButton>
					<BButton variant="danger" class="d-inline-flex align-items-center gap-sm"
						@click="removeCard">
						<BSpinner v-if="submitting" small></BSpinner>
						Yes, Remove my Card
					</BButton>
				</div>
			</template>
		</BModal>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import CreditCardModal from '@js/components/my/bookings/CreditCardModal.vue';
	import CreditCard from '@js/components/my/ui/CreditCard.vue';
	import CreditCardForm from '@js/components/my/client/CreditCardForm.vue';
	import { mapGetters } from 'vuex';

	export default {
		components: {
			CreditCard,
			CreditCardModal,
			CreditCardForm,
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				error: null,
				submitting: false,
			};
		},
		computed: {
			...mapGetters({
				user: 'auth/user',
				isCleaner: 'auth/isCleaner',
			}),
		},
		methods: {
			cardUpdated() {
				this.$store.dispatch('auth/fetchUser');
			},
			async submit() {
				this.submitting = true;

				const token = await this.$refs.creditCardForm.createToken().catch((error) => {
					this.error = error;
				});

				await this.$axios
					.post('/api/account/update-card-and-convert-all-bookings', {
						token: token,
					})
					.then(() => {
						this.$store.dispatch('auth/fetchUser');
					})
					.catch((error) => {
						this.handleError(error);
					});

				this.submitting = false;
			},
			async removeCard() {
				this.submitting = true;

				await this.$axios
					.delete('/api/account/card')
					.then(() => {
						this.$store.dispatch('auth/fetchUser');

						this.$bvModal.hide('remove-credit-card-modal');

						this.$bvModal.msgBoxOk('Your credit card has been removed.', {
							title: 'Credit Card Removed',
							size: 'md',
							okVariant: 'light',
							okTitle: 'Close',
							centered: true,
						});
					})
					.catch((error) => {
						this.handleError(error);
					})
					.finally(() => {
						this.submitting = false;
					});
			},
		},
	};
</script>
